import { render, staticRenderFns } from "./PageIntroBlockTwo.vue?vue&type=template&id=af9aca1a"
import script from "./PageIntroBlockTwo.vue?vue&type=script&lang=js"
export * from "./PageIntroBlockTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports